// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__drR9o","cell":"TableRow_cell__pKJwP","userId":"TableRow_userId__9KydS","operatorName":"TableRow_operatorName__lxT7V","date":"TableRow_date__DF9FI"};